/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Standards_Preset_Deleted_ToastInputs */



/**
* | output |
* | --- |
* | "Standards preset \"{name}\" deleted" |
*
* @param {Standards_Preset_Deleted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_deleted_toast = /** @type {((inputs: Standards_Preset_Deleted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Deleted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
});